<section>
    <div class="avatar"></div>
    <h1>David Ortiz</h1>
    <h3>
        Full-time Front-end/Software/React Engineer <br />
        Saint Cloud, FL
    </h3>
</section>

<style>
    .avatar {
        background-color: cadetblue;
        border-radius: 50%;
        height: 250px;
        margin: 2rem auto;
        width: 250px;
    }
</style>